import Departemen from "../../../../../components/categories/superadmin/master_data/departemen/Home"

export default function Home() {  
  return (
    <Departemen />
  );
}
